import { render, staticRenderFns } from "./newMessage.vue?vue&type=template&id=78cb80e6&scoped=true"
import script from "./newMessage.vue?vue&type=script&lang=js"
export * from "./newMessage.vue?vue&type=script&lang=js"
import style0 from "./newMessage.vue?vue&type=style&index=0&id=78cb80e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cb80e6",
  null
  
)

export default component.exports